import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { frame: String };
  declare readonly frameValue?: string;
  declare readonly hasFrameValue: boolean;

  connect() {
  }

  selectTab = e => {
    const selectedOpt = e.target.children[e.target.selectedIndex],
        path = selectedOpt?.value;
    if (!path?.length) return;
    Turbo.visit(path, { frame: this.frameValue });
  }
}
